module.exports = __webpack_public_path__ + "media/clip_11.424f29fc.mp4";